// POPUPS actions
export const POPUPS_ADDED_SUCCESS = 'POPUPS_ADDED_SUCCESS';
export const POPUPS_ALBUM_SUCCESS = 'POPUPS_ALBUM_SUCCESS';
export const POPUPS_APPROVAL_REQUEST = 'POPUPS_APPROVAL_REQUEST';
